export default __webpack_public_path__ + "locales/fr/PeopleTranslations.json?hash=895af649458a84e9517a59e7ec92a4ac";